import React from 'react';
import { RouteComponentProps } from 'react-router';

import useMaintenance from 'core/hooks/useMaintenance';

import MaintenanceForm from './MaintenancePage/MaintenanceForm';
import MaintenancePage from './MaintenancePage/MaintenancePage';

type Props = RouteComponentProps<{ id: string }>;

export default function MaintenanceDetail({ match }: Props) {
  const { maintenance } = useMaintenance(match.params.id);

  const onSubmit = () => {};

  return (
    <MaintenanceForm
      id={+match.params.id}
      maintenance={maintenance}
      onSubmit={onSubmit}
    >
      <MaintenancePage
        title={maintenance ? `Huolto ${maintenance.id}` : '-'}
        subtitle={
          maintenance && maintenance.vehicle ? maintenance.vehicle.reg : '-'
        }
        vehicleId={maintenance ? maintenance.vehicle_id : undefined}
      />
    </MaintenanceForm>
  );
}
